import React from 'react';
import { Heart, Mail, Instagram, Twitter, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-text-tertiary/20 mt-xxxl">
      <div className="max-w-7xl mx-auto px-horizontal py-vertical">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-xl mb-xl">

          <div className="col-span-2 md:col-span-1">
            <h3 className="text-title-3 font-rounded text-primary mb-md">Nutrius</h3>
            <p className="text-footnote text-text-secondary mb-md">
              Your complete nutrition platform for healthy living, meal planning, and wellness tracking.
            </p>
            <p className="text-caption text-text-secondary">A product of HealthWealth LLC</p>
          </div>

          <div>
            <h4 className="text-callout font-semibold text-text-primary mb-md">Product</h4>
            <ul className="space-y-sm">
              <li><Link to="/products"  className="text-footnote text-text-secondary hover:text-primary transition-quick">Products</Link></li>
              <li><Link to="/recipes"   className="text-footnote text-text-secondary hover:text-primary transition-quick">Recipes</Link></li>
              <li><Link to="/community" className="text-footnote text-text-secondary hover:text-primary transition-quick">Community</Link></li>
              <li><Link to="/pantry"    className="text-footnote text-text-secondary hover:text-primary transition-quick">Pantry</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-callout font-semibold text-text-primary mb-md">Account</h4>
            <ul className="space-y-sm">
              <li><Link to="/dashboard"     className="text-footnote text-text-secondary hover:text-primary transition-quick">Dashboard</Link></li>
              <li><Link to="/profile"       className="text-footnote text-text-secondary hover:text-primary transition-quick">Profile</Link></li>
              <li><Link to="/grocery-lists" className="text-footnote text-text-secondary hover:text-primary transition-quick">Grocery Lists</Link></li>
              <li><Link to="/care-profiles" className="text-footnote text-text-secondary hover:text-primary transition-quick">Care Profiles</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-callout font-semibold text-text-primary mb-md">Company</h4>
            <ul className="space-y-sm">
              <li><Link to="/about"   className="text-footnote text-text-secondary hover:text-primary transition-quick">About Us</Link></li>
              <li><Link to="/contact" className="text-footnote text-text-secondary hover:text-primary transition-quick">Contact</Link></li>
              <li><Link to="/privacy" className="text-footnote text-text-secondary hover:text-primary transition-quick">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-callout font-semibold text-text-primary mb-md">Connect</h4>
            <ul className="space-y-sm mb-lg">
              <li><Link to="/login"  className="text-footnote text-text-secondary hover:text-primary transition-quick">Sign In</Link></li>
              <li><Link to="/signup" className="text-footnote text-text-secondary hover:text-primary transition-quick">Create Account</Link></li>
            </ul>
            <div className="flex gap-sm">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-quick" aria-label="Instagram">
                <Instagram size={16} className="text-primary" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-quick" aria-label="Twitter">
                <Twitter size={16} className="text-primary" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-quick" aria-label="Facebook">
                <Facebook size={16} className="text-primary" />
              </a>
              <a href="mailto:hello@nutrius.co" className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-quick" aria-label="Email">
                <Mail size={16} className="text-primary" />
              </a>
            </div>
          </div>

        </div>
        <div className="pt-lg border-t border-text-tertiary/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-md">
            <p className="text-footnote text-text-secondary">© {currentYear} HealthWealth LLC. All rights reserved.</p>
            <p className="text-footnote text-text-secondary flex items-center gap-xs">
              Made with <Heart size={14} className="text-error fill-error mx-xs" /> for your health
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;